import { jsx as _jsx } from "react/jsx-runtime";
import DepositInfo from "components/DepositInfo";
export function DepositTxnInfo(_a) {
    var info = _a.info;
    return (_jsx(DepositInfo, { info: info, timeRemaining: "", showUnExpiredContent: true }));
}
